import { countriesTranslation } from '../constants';

const countriesTranslationCodes = countriesTranslation.map((el) => el.value);
export type LanguageCode = Lowercase<typeof countriesTranslationCodes[number]>;
